module.exports = __webpack_public_path__ + "img/ic_shuzihua.fd9bf3d0.svg";